import { message } from 'antd';
import FooterLogo from 'assets/imgs/svg/new_topbar_logo.svg';
import { flexColumn, vw } from 'components/common/Common';
import dayjs from 'dayjs';
import React, { useReducer } from 'react';
import styled from 'styled-components';
import { regularCheck, setLocalStorage } from 'untils/auth';
import { charterEmail } from 'untils/constant/email';
import { flexGap } from 'untils/polyfill/flex';
import SuccessfulState from '../coupons/SuccessfulState';

const initForm = {
  isCheck: false,
  email: '',
  ruleEmail: true,
  activityState: false,
};

const NewFooter = styled.footer`
  --footer-section-width: calc(100vw - ${vw(240)});

  width: 100%;
  position: relative;
  color: #fff;
  font-size: ${vw(16)};
  padding: ${vw(40)} ${vw(0)};
  background: #0e142d top right / contain no-repeat url('/imgs/svg/footer-background.svg');
`;

const Max = styled.div`
  width: var(--footer-section-width);
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`;

const FooterLinkContainer = styled.div`
  flex: 1;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(178px, 1fr));
  ${flexGap('16px')}
  justify-content: space-between;
`;

const FooterLinks = styled.div`
  ${flexColumn}
  ${flexGap('16px')}
`;

const FooterContent = styled.div`
  height: 100%;
  width: 100%;
  max-width: ${vw(180)};
`;

const FooterNavH4 = styled.h4`
  color: #fff;
  font-size: ${vw(16)};
  font-weight: 600;
  margin-bottom: ${vw(16)};
`;

const FootLink = styled.a`
  cursor: pointer;
  color: #fff;
  font-size: ${vw(16)};
  font-weight: 300;
  line-height: normal;

  i {
    font-style: normal;
    position: relative;
  }

  &:hover {
    i {
      color: #fff;
      font-weight: 700;

      &::before {
        content: '';
        width: ${vw(24)};
        height: ${vw(24)};
        background-image: url('../../imgs/svg/down_j.svg');
        background-repeat: no-repeat;
        background-size: contain;
        position: absolute;
        transform: rotate(-90deg);
        right: ${vw(-32)};
        top: 50%;
        margin-top: ${vw(-12)};
      }
    }
  }
`;

const SubForm = styled.form`
  width: ${vw(474)};
`;

const SubFormTitle = styled.h4`
  font-size: ${vw(16)};
  font-weight: 500;
  color: #fff;
`;

const EmailInputContainer = styled.div`
  margin-top: ${vw(16)};
  margin-bottom: ${vw(8)};
  display: flex;
  ${flexGap('16px')}
  input {
    flex: 1;
    height: ${vw(40)};
    outline: none;
    border: none;
    border-radius: ${vw(4)};
    color: #07080a;
    padding-left: ${vw(10)};
    ::placeholder {
      font-size: ${vw(16)};
      color: #353959;
      font-weight: 300;
    }
  }
  button {
    width: ${vw(180)};
    height: ${vw(40)};
    border-radius: ${vw(4)};
    background-color: #0063db;
    border: none;
    color: #fff;
    font-size: ${vw(14)};
    font-weight: 700;
    line-height: ${vw(22)};
    cursor: pointer;
  }
  .error-text {
    font-size: ${vw(14)};
    color: #ff4e4b;
    position: absolute;
  }
`;

const AgreementContainer = styled.div`
  display: flex;
  height: ${vw(52)};
  align-items: center;
  p {
    font-size: ${vw(12)};
    color: #fff;
    a {
      display: inline-block;
      margin: 0;
      font-weight: 400;
      text-decoration: underline;
      color: #fff !important;
      font-size: ${vw(12)};
    }
  }
`;

const Icon = styled.i`
  display: block;
  width: ${vw(24)};
  height: ${vw(24)};
  border-radius: ${vw(4)};
  background-color: transparent;
  border: ${vw(2)} solid rgba(255, 255, 255, 0.2);

  cursor: pointer;
  margin-right: ${vw(16)};
  &.active {
    border-radius: ${vw(4)};
    border: none;
    background-image: url('/imgs/svg/selected.svg');
  }
`;

const SocialIcon = styled.ul`
  display: flex;
  ${flexGap('24px')}
  a {
    width: ${vw(24)};
    height: ${vw(24)};
  }
  img {
    width: 100%;
    cursor: pointer;
  }
`;

const LogoSection = styled.div`
  display: flex;
  align-items: center;
  ${flexGap('40px')}
  flex-wrap: wrap;
`;

const LogoInnerSection = styled.div`
  display: flex;
  align-items: center;
  ${flexGap('16px')}
  justify-content: center;
`;

const CopyRight = styled.p`
  text-align: center;
  font-size: ${vw(12)};
  white-space: nowrap;
  color: #fff;
  font-weight: 300;
`;
const LogoText = styled.p`
  font-size: ${vw(12)};
  text-align: center;
  white-space: nowrap;
  color: #fff;
  font-weight: 300;
`;

const PaymentIcon = styled.div`
  width: fit-content;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${vw(24)};
`;

const Currency = styled.img`
  width: ${vw(88)};
  height: ${vw(24)};
`;

const Methods = styled.div`
  display: flex;
  width: fit-content;
  gap: ${vw(8)};
`;

const Method = styled.img`
  width: ${vw(48)};
  height: ${vw(24)};
`;

const LogoImage = styled.img`
  width: ${vw(144)} !important;
`;

const Separator = styled.hr`
  width: var(--footer-section-width);
  margin: ${vw(40)} auto;
  border: 1px solid #1f68db;
`;

const LegalText = styled.p`
  text-align: left;
  color: #fff;
`;

const LegalInfo = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: ${vw(6)};
`;

const LegalInfoContent = styled.div`
  font-size: ${vw(10)};
`;

const Social = styled.div`
  height: fit-content;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  flex-direction: column;
  gap: ${vw(24)};
`;

const PaymentMax = styled(Max)`
  margin: ${vw(30)} auto ${vw(40)};
`;

const LegalMax = styled(Max)`
  flex-direction: column;
  font-size: ${vw(10)};
`;

const ResponsiveFooter = () => {
  const currentYear = dayjs().format('YYYY');

  const [{ isCheck, email, ruleEmail, activityState }, setState] = useReducer(
    (current, update) => ({
      ...current,
      ...update,
    }),
    initForm
  );

  const onFinish = (e) => {
    e.preventDefault();

    if (!isCheck) {
      return message.warning('Please check Terms and Conditions.');
    }
    if (!email) {
      setState({
        ruleEmail: false,
      });
    }

    setLocalStorage(
      'accountRegister',
      JSON.stringify({
        account: email,
        rcvEmailFlag: 1,
      })
    );
    setState({
      activityState: true,
    });
  };

  return (
    <>
      <NewFooter>
        <Max>
          <LogoSection>
            <picture>
              <source srcSet={FooterLogo} media="(max-width: 768px)" width={232} height={63} />
              <LogoImage src={'/imgs/svg/home/logo.svg'} alt="example" className="footer-logo" />
            </picture>
          </LogoSection>
          <SubForm onSubmit={onFinish} id="subscribe-footer-form">
            <SubFormTitle>Get the Latest Updates!</SubFormTitle>
            <EmailInputContainer>
              <input
                type="text"
                value={email}
                placeholder="Enter your email"
                onChange={(e) => setState({ email: e.target.value })}
                onBlur={(e) => {
                  if (e.target.value) {
                    setState({ ruleEmail: regularCheck('email', e.target.value) });
                  }
                }}
              />
              <button type="submit">Subscribe</button>
              {!ruleEmail && <div className="error-text">Please enter a valid email address</div>}
            </EmailInputContainer>
            <AgreementContainer>
              <button
                onClick={() => {
                  setState({ isCheck: !isCheck });
                }}
              >
                <Icon className={`bg-image ${isCheck ? 'active' : ''}`}></Icon>
              </button>
              <p>
                By subscribing, you agree to subscribe to the Airacer Newsletter, and agree to{' '}
                <FootLink href="/termOfUse">Terms & Conditions</FootLink> and{' '}
                <FootLink href="/privacyPolicy">Privacy Policy</FootLink>
              </p>
            </AgreementContainer>
          </SubForm>
        </Max>
        <Separator />

        <Max>
          <FooterLinkContainer>
            <FooterContent>
              <FooterNavH4>Company</FooterNavH4>
              <FooterLinks>
                <FootLink href="/aboutUs" target="_blank" rel="noreferrer">
                  <i>About us</i>
                </FootLink>
                <FootLink href="/contactUs" target="_blank" rel="noreferrer">
                  <i>Contact us</i>
                </FootLink>
                <FootLink href="/partnerWithUs" target="_blank" rel="noreferrer">
                  <i>Partner with us</i>
                </FootLink>
                <FootLink href="/affiliatePartner" target="_blank" rel="noreferrer">
                  <i>Become an affiliate partner</i>
                </FootLink>
              </FooterLinks>
            </FooterContent>
            <FooterContent>
              <FooterNavH4>Explore</FooterNavH4>
              <FooterLinks>
                <FootLink href="/charterQuote" target="_blank">
                  <i>Private charter flights</i>
                </FootLink>
                <FootLink href="/emptyLeg" target="_blank">
                  <i>Empty leg flights</i>
                </FootLink>{' '}
                <FootLink href="/membership" target="_blank">
                  <i>Memberships</i>
                </FootLink>{' '}
                <FootLink href="/jet-card-membership" target="_blank">
                  <i>Jet card programs</i>
                </FootLink>{' '}
                <FootLink href="/private-jets" target="_blank">
                  <i>Private jet types</i>
                </FootLink>{' '}
              </FooterLinks>
            </FooterContent>
            <FooterContent>
              <FooterNavH4>Contact Us</FooterNavH4>
              <FooterLinks>
                <p>
                  <FootLink href={`mailto:${charterEmail}`}>{charterEmail}</FootLink>
                </p>
                <p>+1 800-213-5051</p>
                <FootLink href="/blog/private-jet-services" target="_blank" rel="noreferrer">
                  <i>Media Kit</i>
                </FootLink>
                <FootLink href="/blog" target="_blank">
                  <i>Blog</i>
                </FootLink>
              </FooterLinks>
            </FooterContent>
            <FooterContent>
              <FooterNavH4>Legal</FooterNavH4>
              <FooterLinks>
                <FootLink href="/termOfUse" target="_blank">
                  <i>Terms and Conditions</i>
                </FootLink>
                <FootLink href="/privacyPolicy" target="_blank">
                  <i>Privacy Policy</i>
                </FootLink>
              </FooterLinks>
            </FooterContent>
          </FooterLinkContainer>

          <Social>
            <SocialIcon>
              <a href="https://www.instagram.com/airacer_inc/" target="_blank" rel="noreferrer">
                <img src="/imgs/svg/icon_Instagram.svg" alt="icon-instagram" />
              </a>
              <a href="https://www.facebook.com/airacer.inc/" target="_blank" rel="noreferrer">
                <img src="/imgs/svg/icon_Facebook.svg" alt="icon-facebook" />
              </a>
              <a
                href="https://www.tiktok.com/@airacer.inc?_t=ZP-8xpKv4rIwVq&_r=1"
                target="_blank"
                rel="noreferrer"
              >
                <img src="/imgs/svg/icon_TikTok.svg" alt="icon-instagram" />
              </a>
              <a
                href="https://www.linkedin.com/company/airacer-inc/"
                target="_blank"
                rel="noreferrer"
              >
                <img src="/imgs/svg/icon_LinkedIn_.svg" alt="icon-linkedin" />
              </a>
              <a
                href="https://www.threads.com/@airacer_inc"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src="/imgs/svg/icon_Threads.svg" alt="icon-twitter" />
              </a>
              <a href="https://twitter.com/airacer_inc" target="_blank" rel="noreferrer">
                <img src="/imgs/svg/icon_Twitter.svg" alt="icon-twitter" />
              </a>
              <a
                href="https://youtube.com/@airacerinc?si=8GKdK-4cb4B5G7zM"
                target="_blank"
                rel="noreferrer"
              >
                <img src="/imgs/svg/icon_Youtube.svg" alt="icon-twitter" />
              </a>
            </SocialIcon>
            <div>
              <img
                style={{ width: 178, height: 61 }}
                src={'/imgs/svg/logo-nbaa.svg'}
                alt="airacer is a proud member of the National Business Aviation Association"
                className="logo-nbaa"
                width={178}
                height={61}
              />
            </div>
          </Social>
        </Max>

        <PaymentMax>
          <LogoInnerSection>
            <LogoText>Ace the way you fly</LogoText>
            <CopyRight>©{currentYear} Airacer Inc. All rights reserved.</CopyRight>
          </LogoInnerSection>
          <PaymentIcon>
            <Currency
              src="/imgs/svg/home/payment/icon_Currency.svg"
              alt="pay for your private jet flight using cryptocurrency using coinbase"
            />
            <Methods>
              <Method src="/imgs/svg/home/payment/apple_pay.svg" alt="apple pay icon" />
              <Method src="/imgs/svg/home/payment/google_pay.svg" alt="google pay icon" />
              <Method src="/imgs/svg/home/payment/mastercard.svg" alt="mastercard icon" />
              <Method
                src="/imgs/svg/home/payment/american_express.svg"
                alt="american express icon"
              />
              <Method src="/imgs/svg/home/payment/visa.svg" alt="visa icon" />
              <Method src="/imgs/svg/home/payment/discover.svg" alt="discover icon" />
              <Method
                src="/imgs/svg/home/payment/jcb_global_payment.svg"
                alt="jcb global payment icon"
              />
            </Methods>
          </PaymentIcon>
        </PaymentMax>

        <LegalMax>
          <LegalText>
            {
              'Airacer Inc. (“Airacer”) acts as an air charter broker to arrange on-demand, single entity charter flights operated by air carriers that hold all required economic and safety authorizations from the U.S. Department of Transportation (“DOT”), the Federal Aviation Administration (“FAA”) and, as applicable, foreign civil aviation authorities (“CAAs”). Such carriers exercise operational control over all charter flights arranged through Airacer. Airacer does not own or operate any aircraft and is not a direct air carrier. Airacer additionally arranges aircraft management services for aircraft owners and lessees, provided by air carriers or other operators holding all required DOT, FAA, and foreign CAA authorizations. © 2024, Airacer Inc.'
            }
          </LegalText>
          <LegalInfo>
            <LegalInfoContent>{currentYear} Airacer Inc.</LegalInfoContent>
            <LegalInfoContent>Privacy and Legal Information</LegalInfoContent>
          </LegalInfo>
        </LegalMax>
      </NewFooter>
      {activityState && (
        <SuccessfulState
          type={'foot-register'}
          couponsHandleCancel={() => {
            setState({
              activityState: false,
            });
          }}
        />
      )}
    </>
  );
};

export default ResponsiveFooter;
